<!--<div class="window">-->
<!--  <div class="window-caption">-->
<!--    <span class="icon mif-tag fg-green"></span>-->
<!--    <span class="title">{{configComponent.titlePage | translate}}</span>-->
<!--    <div class="buttons">-->
<!--      <span class="btn-min"></span>-->
<!--      <span class="btn-max"></span>-->
<!--      <span class="btn-close" (click)="genericsService.onBackClicked()"></span>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="window-content p-2 tab-height">-->
<!--    <div class="grid p-0">-->
<!--      <div class="row">-->
<!--        <div class=" cell-12 h-auto">-->
<!--          <div data-role="navview" data-toggle="#paneToggle" data-expand="lg" data-compact="fs"-->
<!--               data-active-state="true">-->
<!--            <div class="navview-pane pt-5 mt-3">-->
<!--              <div class="d-flex flex-justify-start">-->
<!--                <button class="pull-button"><span class="default-icon-menu"></span></button>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <app-left-site (emitValueFilterStatusOP)="onFilterStatusOperation($event)" [view]="'transfert-stock'"></app-left-site>&ndash;&gt;-->
<!--              <app-left-site (emitFilterSidebar)="onFilterBySideBar($event)" [view]="configComponent.viewLeftSide"></app-left-site>-->
<!--            </div>-->
<!--            <div class="navview-content p-0 tab-height">-->
<!--              <div class="cell-md-12 pt-0 mt-0">-->
<!--                <div class="card m-0" style="width: auto; overflow: scroll !important;">-->
<!--                  <div class="card-header">-->
<!--                    <div class="row pt-5 mt-3">-->
<!--                      <div class="cell-3"></div>-->
<!--                      <div class="cell-9">-->
<!--                        <m4-input [(ngModel)]="token" placeholder="{{'Search'|translate}}"-->
<!--                                  [search-button]="true" (keyup)="searchElt($event)" name="token"></m4-input>-->
<!--                      </div>-->
<!--                      <div class="cell-12 d-flex flex-justify-end bg-light">-->
<!--                        <div class="h-menu mr-8">-->
<!--                          <button class="mr-2" size="small"  m4-button-->
<!--                                  [disabled]="!currentObject" (click)="showDetails(currentObject)">{{'Afficher' | translate}}</button>-->
<!--                          <button class="mr-2" [disabled]="!currentObject" size="small"  m4-button-->
<!--                                  (click)="aprobation(currentObject, 'VALIDER')">{{'Confirmer' | translate}}</button>-->
<!--                          <button class="mr-2" [disabled]="!currentObject" size="small"  m4-button-->
<!--                                  (click)="aprobation(currentObject, 'REJETER')">{{'Rejeter' | translate}}</button>-->

<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="card-body">-->
<!--                    <table class="table table-border cell-border subcompact striped">-->
<!--                      <thead>-->
<!--                      <tr style="background-color:#3c6478">-->
<!--                        <th class="fg-white">-->
<!--                          {{'#' | translate}}-->
<!--                        </th>-->
<!--                        <th class="fg-white" *ngFor="let header of dataMapper"-->
<!--                            [ngClass]="{'focus-header': orderBy === currentCol(header)}"-->
<!--                            (click)="getItemHeaderToSort(header)">{{ header.header | translate}}</th>-->
<!--                      </tr>-->
<!--                      </thead>-->
<!--                      <tbody *ngIf="dataApi">-->
<!--                      <tr *ngFor="let row of dataApi | paginate:-->
<!--                  { id: configComponent.idPagination, currentPage: page + 1,  itemsPerPage: size, totalItems: totalItems }; let i=index;"-->
<!--                          class="clickable" (click)="onSelect(row)"-->
<!--                          [ngClass]="{'bg-gray' : row.id == currentObject?.id }">-->
<!--                        <td>{{ i+1 }}</td>-->
<!--                        <td *ngFor="let key of dataMapper">-->
<!--                        <span *ngIf="key.type === 'CHAINE'">-->
<!--                        {{ getFieldValue(row, key.field) }}-->
<!--                        </span>-->
<!--                          <span *ngIf="key.type === 'DATE'">-->
<!--                        {{ getFieldValue(row, key.field) | date: 'dd-MM-YYY : HH:mm:ss' }}-->
<!--                        </span>-->
<!--                        </td>-->
<!--                      </tr>-->
<!--                      </tbody>-->
<!--                    </table>-->
<!--                  </div>-->
<!--                  <div class="cell-md-12 p-0 m-0 text-center">-->
<!--                    <pagination-controls [id]="configComponent.idPagination"-->
<!--                                         (pageChange)="onChangePage($event)"-->
<!--                                         (pageBoundsCorrection)="onChangePage($event)" maxSize="5" directionLinks="true"-->
<!--                                         autoHide="true" responsive="true" previousLabel="{{'<<'|translate}}"-->
<!--                                         nextLabel="{{'>>'|translate}}"></pagination-controls>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<!--<div class="m-0" style="width: auto; overflow: scroll !important;">-->
<!--  <div class="card-header">-->
<!--    <div class="row pt-5 mt-3">-->
<!--      <div class="cell-3"></div>-->
<!--      <div class="cell-9">-->
<!--        <m4-input [(ngModel)]="token" placeholder="{{'Search'|translate}}"-->
<!--                  [search-button]="true" (keyup)="searchElt($event)" name="token"></m4-input>-->
<!--      </div>-->
<!--      <div class="cell-12 d-flex flex-justify-end bg-light">-->
<!--        <div class="h-menu mr-8">-->
<!--          <button class="mr-2" size="small"  m4-button-->
<!--                  [disabled]="!currentObject" (click)="showDetails(currentObject)">{{'Afficher' | translate}}</button>-->
<!--          <button class="mr-2" [disabled]="!currentObject" size="small"  m4-button-->
<!--                  (click)="aprobation(currentObject, 'VALIDER')">{{'Confirmer' | translate}}</button>-->
<!--          <button class="mr-2" [disabled]="!currentObject" size="small"  m4-button-->
<!--                  (click)="aprobation(currentObject, 'REJETER')">{{'Rejeter' | translate}}</button>-->

<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="card-body">-->
<!--    <table class="table table-border cell-border subcompact striped">-->
<!--      <thead>-->
<!--      <tr style="background-color:#3c6478">-->
<!--        <th class="fg-white">-->
<!--          {{'#' | translate}}-->
<!--        </th>-->
<!--        <th class="fg-white" *ngFor="let header of dataMapper"-->
<!--            [ngClass]="{'focus-header': orderBy === currentCol(header)}"-->
<!--            (click)="getItemHeaderToSort(header)">{{ header.header | translate}}</th>-->
<!--      </tr>-->
<!--      </thead>-->
<!--      <tbody *ngIf="dataApi">-->
<!--      <tr *ngFor="let row of dataApi | paginate:-->
<!--                  { id: configComponent.idPagination, currentPage: page + 1,  itemsPerPage: size, totalItems: totalItems }; let i=index;"-->
<!--          class="clickable" (click)="onSelect(row)"-->
<!--          [ngClass]="{'bg-gray' : row.id == currentObject?.id }">-->
<!--        <td>{{ i+1 }}</td>-->
<!--        <td *ngFor="let key of dataMapper">-->
<!--                        <span *ngIf="key.type === 'CHAINE'">-->
<!--                        {{ getFieldValue(row, key.field) }}-->
<!--                        </span>-->
<!--          <span *ngIf="key.type === 'DATE'">-->
<!--                        {{ getFieldValue(row, key.field) | date: 'dd-MM-YYY : HH:mm:ss' }}-->
<!--                        </span>-->
<!--        </td>-->
<!--      </tr>-->
<!--      </tbody>-->
<!--    </table>-->
<!--  </div>-->
<!--  <div class="cell-md-12 p-0 m-0 text-center">-->
<!--    <pagination-controls [id]="configComponent.idPagination"-->
<!--                         (pageChange)="onChangePage($event)"-->
<!--                         (pageBoundsCorrection)="onChangePage($event)" maxSize="5" directionLinks="true"-->
<!--                         autoHide="true" responsive="true" previousLabel="{{'<<'|translate}}"-->
<!--                         nextLabel="{{'>>'|translate}}"></pagination-controls>-->
<!--  </div>-->
<!--</div>-->






<div class="card-body">
  <table class="table table-border cell-border subcompact striped">
    <thead>
    <tr style="background-color:#3c6478">
      <th class="fg-white">
        {{'#' | translate}}
      </th>
      <th class="fg-white" *ngFor="let header of dataMapper"
          [ngClass]="{'focus-header': orderBy === currentCol(header)}"
          (click)="getItemHeaderToSort(header)">{{ header.header | translate}}</th>
    </tr>
    </thead>
    <tbody *ngIf="dataApi">
    <tr *ngFor="let row of dataApi | paginate:
                  { id: configComponent.idPagination, currentPage: page + 1,  itemsPerPage: size, totalItems: totalItems }; let i=index;"
        class="clickable" (click)="onSelect(row, 'click')"
        [ngClass]="{'bg-gray' : row.id == currentObject?.id }">
      <td>{{ i+1 }}</td>
      <td *ngFor="let key of dataMapper">
                        <span *ngIf="key.type === 'CHAINE'">
                        {{ getFieldValue(row, key.field) }}
                        </span>
        <span *ngIf="key.type === 'DATE'">
                        {{ getFieldValue(row, key.field) | date: 'dd-MM-YYY : HH:mm:ss' }}
                        </span>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<div class="cell-md-12 p-0 m-0 text-center">
  <pagination-controls [id]="configComponent.idPagination"
                       (pageChange)="onChangePage($event)"
                       (pageBoundsCorrection)="onChangePage($event)" maxSize="5" directionLinks="true"
                       autoHide="true" responsive="true" previousLabel="{{'<<'|translate}}"
                       nextLabel="{{'>>'|translate}}"></pagination-controls>
</div>


